import http from './http'

const base = '/Telas/Cobranca'

export default {
  async getPaged (params) { return (await http.get(`${base}/GetPaged`, { params })).data },
  async getById (id) { return (await http.get(`${base}/GetById/${id}`)).data },
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async getPaymentCandidates (id) { return (await http.get(`${base}/GetPaymentCandidates/${id}`)).data },
  async add (input) { return (await http.post(`${base}/Add`, input)).data },
  async addBatch (input) { return (await http.post(`${base}/AddBatch`, input)).data },
  async reissue (id, expirationAt) { return (await http.post(`${base}/Reissue/${id}`, { expirationAt: expirationAt || null })).data },
  async cancel (id, reason) { await http.post(`${base}/Cancel/${id}`, { reason }) },
  async cancelBatch (chargeIds, reason) { await http.post(`${base}/CancelBatch`, { chargeIds, reason }) },
  async linkPayment (id, input) { await http.post(`${base}/LinkPayment/${id}`, input) }
}
